//Show OTP when api is match
export const showOTPAPI = ["http://192.168.1.10:3100/api","http://192.168.1.45:3100/api","https://ileadnewapi.secretdemo.com/api"]
